
export const follow = 
[

    {
        id: 1,
        name: "Purva",
        username: "puru",
        image: "https://th.bing.com/th/id/OIP.7jMSYFuDo3sCkiLImQ0aNAAAAA?pid=ImgDet&w=300&h=300&rs=1",
        isFollowed: true,
        followers: 5,
        following: 2,
        bio : "Full Stack Developer"

    },{
        id: 2,
        name: "Nishtha",
        username :"niku",
        image:"https://th.bing.com/th/id/OIP.7jMSYFuDo3sCkiLImQ0aNAAAAA?pid=ImgDet&w=300&h=300&rs=1",
        isFollowed: false,
        followers: 7,
        following: 3,
        bio : "Frontend Developer"


    },
    {
        id: 3,
        name: "Ankita",
        username: "ahana",
        image:"https://th.bing.com/th/id/OIP.7jMSYFuDo3sCkiLImQ0aNAAAAA?pid=ImgDet&w=300&h=300&rs=1",
        isFollowed: false,
        followers: 2,
        following: 4,
        bio:"Backend Developer"
    }

]